export const PLUGIN_NAME = "basic";
